<script>
  import { format } from 'svelte-i18n';
  import { Tooltip } from '@sveltestrap/sveltestrap';

  import { SparkChart } from '@client/components/charts';
  import { Spinner } from '@client/components/spinner';

  import { shortenNumber } from '@common/utils/numbers';

  const id = `tooltip-${Math.random().toString(36).substring(2, 15)}`;
  export let data = {};
  export let domain = {};
</script>

<div class="spark">
  {#if data?.spark}
    <SparkChart data={data.spark} />
  {/if}
</div>

<div class="kpis" class:adjust={domain?.stamped > 0 || domain?.outlookaddin > 0}>
  <div class="metrics">
    <div>
      <div class="metric">{@html $format('label.KPI.ACTIVE_USERS')}</div>
      <div class="value">
        {#if data?.users !== undefined}
          <span id="{id}-users">{shortenNumber(data.users, 1)}</span>

          {#if data.users > 999}
            <Tooltip target="{id}-users">
              {data.users.toLocaleString()}
            </Tooltip>
          {/if}
        {:else}
          <div class="loader">
            <Spinner show inline />
          </div>
        {/if}
      </div>
    </div>

    {#if domain?.stamped > 0}
      <div>
        <div class="metric">{@html $format('label.KPI.STAMPED_USERS')}</div>
        <div class="value">
          {#if domain?.stamped !== undefined}
            <span id="{id}-stamped">{shortenNumber(domain.stamped, 1)}</span>

            {#if domain.stamped > 999}
              <Tooltip target="{id}-stamped">
                {domain.stamped.toLocaleString()}
              </Tooltip>
            {/if}
          {:else}
            <div class="loader">
              <Spinner show inline />
            </div>
          {/if}
        </div>
      </div>
    {/if}

    {#if domain?.outlookaddin > 0}
      <div>
        <div class="metric">{@html $format('label.KPI.ADDIN_USERS')}</div>
        <div class="value">
          <span id="{id}-outlookaddin">{shortenNumber(domain.outlookaddin, 1)}</span>

          {#if domain.outlookaddin > 999}
            <Tooltip target="{id}-outlookaddin">
              {domain.outlookaddin.toLocaleString()}
            </Tooltip>
          {/if}
        </div>
      </div>
    {/if}

    <div>
      <div class="metric">{@html $format('label.KPI.BANNER_UPDATES')}</div>
      <div class="value">
        {#if data?.adchanges !== undefined}
          <span id="{id}-adchanges">{shortenNumber(data.adchanges, 1)}</span>

          {#if data.adchanges > 999}
            <Tooltip target="{id}-adchanges">
              {data.adchanges.toLocaleString()}
            </Tooltip>
          {/if}
        {:else}
          <div class="loader">
            <Spinner show inline />
          </div>
        {/if}
      </div>
    </div>
    <div>
      <div class="metric">{@html $format('label.KPI.SIGNATURE_UPDATES')}</div>
      <div class="value">
        {#if data?.tagblockchanges !== undefined}
          <span id="{id}-tagblockchanges">{shortenNumber(data.tagblockchanges, 1)}</span>

          {#if data.tagblockchanges > 999}
            <Tooltip target="{id}-tagblockchanges">
              {data.tagblockchanges.toLocaleString()}
            </Tooltip>
          {/if}
        {:else}
          <div class="loader">
            <Spinner show inline />
          </div>
        {/if}
      </div>
    </div>
  </div>
</div>

<style lang="scss" src="./kpis.scss"></style>
